<template>
  <el-dialog title="资料上传" :visible.sync="visible" append-to-body width="50%">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="orgForm">
      <el-form-item label="资料类型" prop="type">
        <el-select size="small" v-model="ruleForm.type" clearable placeholder="请选择">
          <el-option v-for="item in typeOptions" :key="item.label" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="文件上传">
        <el-upload class="avatar-uploader" action="#" name="file" ref="upload" accept="image/jpeg,image/pdg,image/png"
          :disabled="fileList.length > 0" :on-change="onChange" :http-request="upLoadFile" :before-upload="handleBefore"
          :auto-upload="false" :on-remove="handleRemove" :before-remove="beforeRemove" :file-list="fileList" multiple
          :limit="1">
          <el-button size="small" type="file" :disabled="fileList.length > 0">点击上传</el-button>
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <!-- <el-button size="small" @click="close()">取消</el-button> -->
      </el-form-item>
    </el-form>

  </el-dialog>


</template>


<script>
export default {
  props: {
    contractId: {
      type: String
    },
    openType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      ruleForm: {
        type: '',
        name: '',
        path: ''
      },
      rules: {
        type: [
          { required: true, message: '请选择资料类型！', trigger: 'change' },
        ],
      },
      fileList: [],
      typeOptions: [
        { label: '被公证合同', value: 0 },
        { label: '公证申请书', value: 1 },
        { label: '公证告知书', value: 2 },
        { label: '受理通知书', value: 3 },
        { label: '公证笔录 ', value: 4 },
        { label: '附件 ', value: 5 },
        { label: '视频 ', value: 6 },
        { label: '合同转让书', value: 7 },
        { label: '拟定公证词', value: 8 },
        { label: '公证书', value: 9 },
        { label: '核实函', value: 10 },
        { label: '执行证书', value: 11 },
        { label: '面诊单', value: 12 },
        { label: '文书送达记录 ', value: 13 },
        { label: '还款记录 ', value: 14 },
        { label: '催收资料 ', value: 15 },
        { label: '执行申请书  ', value: 16 },
        { label: '其他材料 ', value: 17 },
      ]
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 新增材料弹框 1为材料证据 value<9为材料证据  2为执行证据 >9为执行材料
    open(type) {
      const data = this.typeOptions.filter(item => {
        //1为材料证据 value<9为材料证据
        if (type == 1) {
          return item.value<9;
        }
        //2为执行证据 >=9为执行材料
        if(type==2){
          return item.value>=9
        }
      })
      this.typeOptions=data;
      this.visible = true;
    },

    close() {
      this.ruleForm.type = '';
      this.ruleForm.name = '';
      this.ruleForm.path = '';
      this.fileList = [];
      this.visible = false;
    },
    // 移除文件
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    // 改变文件
    onChange(file, fileList) {
      this.fileList = fileList;
      console.log(fileList);
    },
    // 上传到文件服务器
    upLoadFile(data) {
      let param = new FormData();
      param.append('file', data.file);
      this.$api.upLoadFile(param).then(res => {
        this.ruleForm.path = res.data.data.urf;
        this.ruleForm.name = this.fileList[0].name;
        if (this.openType === 'add') {
          this.$store.commit('case/addNotaryDocumentList', JSON.parse(JSON.stringify(this.ruleForm)));
          this.ruleForm.type = '';
          this.ruleForm.name = '';
          this.ruleForm.path = '';
          this.fileList = [];
          console.log('正在上传服务器。。。。。。')
          this.close();
        } else {
          console.log('this.ruleForm的值为', this.ruleForm)
          this.addFile({ ...this.ruleForm });

        }
      })
    },
    // 文件与案件关联
    addFile(reqData) {
      this.$api.addFile({
        type: reqData.type,
        name: reqData.name,
        path: reqData.path,
        contractId: this.contractId
      }).then(res => {
        if (res.data.code === '200') {
          this.$store.commit('case/addNotaryDocumentList', JSON.parse(JSON.stringify(this.ruleForm)));
          this.ruleForm.type = '';
          this.ruleForm.name = '';
          this.ruleForm.path = '';
          this.fileList = [];
          this.$emit('fevent');
          this.close();
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    handleBefore(file) {
      var FileExt = file.name.replace(/.+\./, '')
      if (['jpg', 'png', 'pdf'].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: 'warning',
          message: '请上传后缀名为jpg、png、pdf的附件！',
        })
        return false
      }
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 12px;
}
</style>